module.exports = __webpack_public_path__ + "img/cns_printer_mac10.78ab1374.png";